var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.careCards),function(aCareCard,j){return _c('care-card',{key:`cc-${j}`,staticStyle:{"margin-bottom":"15px"},attrs:{"care-card":aCareCard,"heartbeat":_vm.heartbeat,"profile":_vm.profile,"doc":_vm.doc,"apps":_vm.apps,"section":_vm.section,"planid":_vm.planid}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }